module.exports = __webpack_public_path__ + "icon-password-active.svg?2d5dfc2ed37b0b4807c11ed5501e71d7";